import React from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from '../layouts/BoxedContainer';
import Icons from '../layouts/Icons';

export default function DownloadMobileApp({ data }) {
  const { title, subtitle, text, image, iosLink, androidLink } = data;
  return (
    <section className="bg-red relative lg:-mt-[80px] -mt-[20px] mobile-app">
      <BoxedContainer className="boxed">
        <div className="flex gap-x-[142px] relative">
          <div className="4xl:pl-[300px] 3xl:pl-[200px] 2xl:pl-[100px]">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.4 }}
              viewport={{ once: true }}
              className=" flex flex-col lg:gap-y-[43px] gap-y-[30px] xl:pt-[180px] lg:pt-[120px]
              pt-[90px] xl:pb-[147px] lg:pb-[130px] pb-[90px] max-w-[446px]"
            >
              <div className="flex flex-col lg:gap-y-[27px] gap-y-[13px] max-w-[446px]">
                <h2
                  className="lg:text-2xl text-[36px] leading-[50px] text-white
                font-roboto-condensed-bold flex flex-col uppercase"
                >
                  <span className="bg-white px-[8px] -ml-[8px] text-black w-fit">{title}</span>
                  <span dangerouslySetInnerHTML={{ __html: subtitle }} />
                </h2>
                <p
                  className="lg:text-[16px] text-[15px] lg:leading-[30px] leading-6 text-white
                font-roboto-regular"
                >
                  {text}
                </p>
              </div>
              <div className="flex lg:gap-x-[33px] gap-x-[15px]">
                {iosLink && (
                  <a
                    href={iosLink}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="ios"
                    className="ios"
                  >
                    <Icons icon="ios" className="lg:w-[202px] w-[140px] lg:h-[60px] h-[55px]" />
                  </a>
                )}

                {androidLink && (
                  <a
                    href={androidLink}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="android"
                    className="android"
                  >
                    <Icons
                      icon="google-play-store"
                      className="lg:w-[202px] w-[140px] lg:h-[60px] h-[55px]"
                    />
                  </a>
                )}
              </div>
            </motion.div>
          </div>
          <div className="w-[40%] lg:block hidden">
            {image && (
              <LazyLoadImage
                src={image.url}
                alt="download mobile app"
                className="absolute 4xl:right-[15%] 3xl:right-[8%] right-[4%] -top-[70px]
                h-auto z-20 object-cover"
              />
            )}
          </div>
        </div>
      </BoxedContainer>
    </section>
  );
}
